import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getAllRenterUnits } from 'modules/_common/api';

export const useAllRenterUnitsQuery = (propertyId: string | undefined | null, enabled: boolean) => {
  const { data, isError, isLoading } = useQuery(
    [QUERY_KEYS.LITE_RENTER_UNITS, propertyId],
    () => getAllRenterUnits(propertyId),
    { enabled },
  );

  return {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    units: data?.data || data,
    isUnitsError: isError,
    isUnitsLoading: isLoading,
  };
};
